import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Dropdown, Loader, Dimmer} from 'semantic-ui-react';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';
import CardSearch from './CardSearch';
import Placeholder from './Placeholder';

class SearchFTRResults extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  goToAnswerPage(answerId) {
    this.props.navigateTo(`/formulario/${answerId}/ver`);
  }

  onPageClick(value) {
    this.props.changeSearchFtrListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeSearchFtrListPageSize(data.value);
  }

  renderLoaderOrSearchResults() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Dimmer active inverted className='loading-container'>
          <Loader inverted inline='centered' />
        </Dimmer>
      );
    }
    return this.renderSearchResults();
  }

  renderSearchResults() {
    const {answersList} = this.props;
    if (!answersList.length) {
      return (
        <Placeholder
          image='exclamation'
          text='No hay formularios que cumplan con los filtros ingresados ...'
        />
      );
    }

    return answersList.map((element, index) => {
      const answerId = element._id.$oid;
      const dateFormatted = moment(element.createdDate).format(dateFormatShow);

      const generalInfo = element.generalInfo;
      const dealerName =
        generalInfo && generalInfo.dealerName ? generalInfo.dealerName : '';
      const agencyName =
        generalInfo && generalInfo.agencyName ? generalInfo.agencyName : '';

      const answers = element.answers;
      const title = answers && answers.title ? answers.title : '';
      const cause =
        answers && answers.cause_of_the_problem ?
          answers.cause_of_the_problem :
          '';
      const responsible =
        answers && generalInfo.responsible ? generalInfo.responsible : '';
      const repairDate =
        answers && generalInfo.repairOfDate ?
          moment(generalInfo.repairOfDate).format(dateFormatShow) :
          '';

      return (
        <CardSearch
          key={index}
          text={cause}
          delear={dealerName}
          agencyName={agencyName}
          title={title}
          date={dateFormatted}
          handleClick={() => this.goToAnswerPage(answerId)}
          id={`${element.type} - ${element.formNumber}`}
          responsible={responsible}
          repairDate={repairDate}
        />
      );
    });
  }

  renderPagination() {
    const {totalItems, pageSize, pageNumber} = this.props;
    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <div className='table-pagination'>
        <span className='page-sizer'>
          <strong>Items por página</strong>
          <Dropdown
            selection
            upward
            compact
            value={pageSize}
            options={pageSizes}
            onChange={this.onPageSizeClick}
          />
        </span>
        <TablePaginator
          itemsCount={totalItems}
          itemsPerPage={pageSize}
          selectedPage={pageNumber}
          onOptionClick={this.onPageClick}
        />
      </div>
    );
  }

  render() {
    return (
      <Card fluid raised className='search-result-container'>
        <div className='container__result animated fadeInUp'>
          {this.renderLoaderOrSearchResults()}
          {this.renderPagination()}
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.searchFTR.loading,
    'answersList': state.searchFTR.listByPage,
    'pageNumber': state.searchFTR.pageNumber,
    'pageSize': state.searchFTR.pageSize,
    'totalItems': state.searchFTR.list.length,
  };
};

const {
  navigateTo,
  fetchPublishedAnswersList,
  changeSearchFtrListPage,
  changeSearchFtrListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchPublishedAnswersList,
  changeSearchFtrListPage,
  changeSearchFtrListPageSize,
})(SearchFTRResults);
